var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"hd-preview-box-tab"},_vm._l((_vm.list),function(item,index){return _c('div',{key:index,class:['hd-preview-box-tab-item', _vm.activeIndex == index ? 'active' : ''],on:{"click":function($event){return _vm.onClickChange(index)}}},[_vm._v("\n    "+_vm._s(item)+"\n  ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }